import { Routes, Route, Navigate } from "react-router-dom";
import { Home } from "pages/Home";
import { ProtectedRoute } from "features/auth/components/ProtectedRoute";
import { useAppRoutes } from "./useAppRoutes";
import { ExternalReconciliation } from "pages/ExternalReconciliation";
import { InternalReconciliation } from "pages/InternalReconciliation";
import { ExternalStatistics } from "pages/ExternalStatistics";
import { InternalStatistics } from "pages/InternalStatistics";
import { ClientExport } from "pages/ClientExport";

export const AppRoutes = () => {
  const { isAuthenticated } = useAppRoutes();

  return (
    <>
      {isAuthenticated ? (
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="*" element={<Navigate to="/" />} />
          <Route
            path="/external-reconciliation/:id"
            element={
              <ProtectedRoute>
                <ExternalReconciliation />
              </ProtectedRoute>
            }
          />
          <Route
            path="/internal-reconciliation/:id"
            element={
              <ProtectedRoute>
                <InternalReconciliation />
              </ProtectedRoute>
            }
          />
          <Route
            path="/external-statistics/:id"
            element={
              <ProtectedRoute>
                <ExternalStatistics />
              </ProtectedRoute>
            }
          />
          <Route
            path="/internal-statistics/:id"
            element={
              <ProtectedRoute>
                <InternalStatistics />
              </ProtectedRoute>
            }
          />
          <Route
            path="/client-export"
            element={
              <ProtectedRoute>
                <ClientExport />
              </ProtectedRoute>
            }
          />
        </Routes>
      ) : (
        <></>
      )}
    </>
  );
};
